import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHikeNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M7.707 2.879A3 3 0 019.828 2H11a1 1 0 01.962.725l.797 2.793a7 7 0 004.72 4.782l3.67 1.1A4 4 0 0124 15.233v.399c0 .316-.035.7-.192 1.09a6.493 6.493 0 01-1.95 2.597C20.688 20.26 18.966 21 16.5 21H14a.996.996 0 01-.242-.03l-3.451-.862-.6.6A1 1 0 019 21H4a4 4 0 01-4-4v-.172a3 3 0 01.879-2.12l.161-.163.785-7.844A3 3 0 014.81 4h1.776zM9.828 4a1 1 0 00-.707.293L7.414 6H4.81a1 1 0 00-.995.9l-.71 7.1c2.274.008 3.414.267 4.338.541l.316.095C8.443 14.846 8.95 15 10 15h7.5c.396 0 .609-.108.773-.243.208-.17.38-.413.645-.812l.027-.04c.168-.253.383-.576.664-.878l-2.705-.812a9.005 9.005 0 01-.404-.131l-2.2 2.21-1.417-1.412 1.721-1.729a8.986 8.986 0 01-.817-.596l-1.613 1.619-1.417-1.411 1.633-1.64a9.006 9.006 0 01-.632-.923l-1.78 1.787-1.417-1.412 2.327-2.336a9.187 9.187 0 01-.052-.174L10.246 4zM2.293 16.121a1 1 0 00-.293.707V17a2 2 0 002 2h4.586l1.107-1.107L14.123 19H16.5c2.036 0 3.308-.6 4.104-1.24a4.497 4.497 0 001.349-1.786.938.938 0 00.047-.343v-.399c0-.438-.143-.851-.39-1.187a.98.98 0 00-.383.198c-.208.17-.38.413-.645.812l-.027.04c-.232.35-.554.833-1.016 1.21-.523.428-1.185.695-2.039.695H10c-1.355 0-2.107-.23-2.831-.452l-.294-.09C6.125 16.238 5.155 16 3 16h-.586z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHikeNormalSmall;
